'use client';

import { FavouriteIcon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { useState } from 'react';

interface Order {
  id: string;
  date: string;
  status: string;
  total: string;
  update: string;
  action: string;
}

const defaultOrders: Order[] = [
  {
    id: 'ORD-2023-001',
    date: '2023-05-15',
    status: 'Shipped',
    total: '৳125.99',
    update: '2023-05-16',
    action: 'Track Order',
  },
  {
    id: 'ORD-2023-002',
    date: '2023-05-18',
    status: 'Processing',
    total: '৳89.50',
    update: '2023-05-16',
    action: 'Cancel Order',
  },
  {
    id: 'ORD-2023-003',
    date: '2023-05-15',
    status: 'Delivered',
    total: '৳125.99',
    update: '2023-05-16',
    action: 'Review Order',
  },
];

const MyWishList = () => {
  const [orders, setOrders] = useState<Order[]>(defaultOrders);

  const handleShopNow = () => {
    // You can use this to add more orders if needed
    console.log('Shop Now clicked');
  };

  return (
    <div className="dashboard__content">
      <div className="dashboard__content-header">
        <h5>My Orders</h5>
      </div>

      <div className="dashboard__content-info">
        <div className="dashboard__content-details customer-order">
          <div className="row">
            <div className="col-12">
              <div className="customer-order__table-wrapper table-responsive">
                <table className="customer-order__table table">
                  <thead className="customer-order__thead">
                    <tr>
                      <th>#Order</th>
                      <th>Date</th>
                      <th>Status</th>
                      <th>Total</th>
                      <th>Update</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className="customer-order__tbody">
                    {orders.map((order, index) => (
                      <tr key={index}>
                        <td>{order.id}</td>
                        <td>{order.date}</td>
                        <td>{order.status}</td>
                        <td>{order.total}</td>
                        <td>{order.update}</td>
                        <td>
                          <a href="#" className="customer-order__link">
                            {order.action}
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="text-center">
                  <span>
                    <HugeiconsIcon icon={FavouriteIcon} size={34} />
                  </span>
                  <p className="mb-3">No products added to the wishlist</p>
                  <button
                    onClick={handleShopNow}
                    className="trk-btn trk-btn--primary"
                  >
                    Shop Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyWishList;
